import resource from "../resource";

const endpoints = {
  recap: "evote/v2/recapitulation",
  recapbyFaculty: "evote/v2/recapitulation/faculties",
  recapbyCandidate: "evote/v2/recapitulation/candidates",
  recapbyStatistics: "evote/v2/recapitulation/statistics",
};

export default {
  getRecap: () => {
    const url = `${endpoints.recap}`;
    const request = resource.get(url);
    return request;
  },
  getRecapFaculty: () => {
    // const url = `${endpoints.recapbyFaculty}?type=candidates_breakdown&per_page=100`;
    const url = `${endpoints.recapbyFaculty}?per_page=100`;
    const request = resource.get(url);
    return request;
  },
  getRecapCandidate: () => {
    const url = `${endpoints.recapbyCandidate}`;
    const request = resource.get(url);
    return request;
  },
  getRecapStatistics: () => {
    const url = `${endpoints.recapbyStatistics}`;
    const request = resource.get(url);
    return request;
  },
};
